import { render, staticRenderFns } from "./ResumenVacacionesModal.vue?vue&type=template&id=16c54577"
import script from "./ResumenVacacionesModal.vue?vue&type=script&lang=js"
export * from "./ResumenVacacionesModal.vue?vue&type=script&lang=js"
import style0 from "./ResumenVacacionesModal.vue?vue&type=style&index=0&id=16c54577&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports